import { createStyles } from 'antd-style'

export const useStyle = createStyles(
  (_, props: { applicationIcon?: string }) => ({
    select: { width: 240 },
    applicationIcon: {
      backgroundColor: props?.applicationIcon
    }
  })
)
